import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { NotificationManager } from 'react-notifications';
import { isAdminSelector } from '../../components/store/auth/selectors';
import { useAccessToken } from '../../components/common/hooks/useAccessToken';
import { selectCustomStyles } from '../../components/common/shared/select.styled';
import Input from '../../components/common/simple/input';
import { showLoader, hideLoader } from '../../components/store/common/slice';
import PartnersAndBuildingsDropdowns from '../components/PartnersAndBuildingsDropdowns/PartnersAndBuildingsDropdowns';
import { StyledDropdownWrapper } from '../components/PartnersAndBuildingsDropdowns/PartnersAndBuildingsDropdowns.styled';
import { StyledUserActions } from './UserActionsPage.styled';

const UserActionsPage = () => {
    const isAdmin = useSelector(isAdminSelector);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const client = useAccessToken();
    const partnersList = useSelector(state => state.admin.partnersList);

    const [editUserOptions, setEditUserOptions] = useState([]);
    const [currentEditUser, setCurrentEditUser] = useState();
    const [inputValues, setInputValues] = useState({
        user: '',
        phone: '',
        email: ''
    });
    const [currentPartner, setCurrentPartner] = useState([]);
    const [currentBuildings, setCurrentBuildings] = useState([]);
    const [disabledBtn, setDisabledBtn] = useState(true);

    useEffect(() => {
        if (!client) return;
        (async function () {
            dispatch(showLoader());
            
            const { users } = await client.get('/operations/data/users');
            if (users) {
                const options = users.map(({ userID }) => ({ value: userID, label: userID }));
                setEditUserOptions([
                    ...editUserOptions,
                    ...options
                ]);
            } 

            dispatch(hideLoader());
        })();
    }, [client])

    const getUserInfo = async () => {
        if (currentEditUser.value === 'new') return
        else {
            dispatch(showLoader());
            
            const result = await client.get('/operations/data/users');
            if (result.users) {
                const item = result.users.filter(user => user.userID === currentEditUser.value);

                setInputValues({
                    user: `${item[0].firstName} ${item[0].lastName}`,
                    phone: item[0].phone,
                    email: item[0].userID
                });

                const partnerOption = partnersList.filter(partner => partner.value === item[0].partnerID);
                setCurrentPartner(partnerOption);
            } 

            dispatch(hideLoader());
        }
    };

    const onEditUserDropdownChange = e => setCurrentEditUser(e);

    useEffect(() => {
        if (currentEditUser?.value) {
            getUserInfo();
            setDisabledBtn(false);
        } else setDisabledBtn(true);
    }, [currentEditUser])

    const onPartnerChange = e => setCurrentPartner(e);

    const onBuildingsChange = e => setCurrentBuildings(e);

    const onInputChange = e => {
        const targ = e.target;
        setInputValues({
            ...inputValues,
            [targ.name]: targ.value
        })
    };

    const onUpdateCreateClick = () => {
        //send data to back
        //if (result)
        NotificationManager.success(t('userActions.success'));
        setTimeout(() => window.location.reload(), 2000);
    };

    if (!isAdmin) return <div>{t('searchPayments.noAdminRights')}</div>;

    return (
        <StyledUserActions>
            <StyledDropdownWrapper className='wrapper'>
                <label className="label">{t('userActions.labels.editOrCreate')}</label>
                <Select
                    styles={selectCustomStyles}
                    options={editUserOptions}
                    value={currentEditUser}
                    onChange={onEditUserDropdownChange}
                    name="editUser"
                />
            </StyledDropdownWrapper>

            <div className='container'>
                <PartnersAndBuildingsDropdowns 
                    onPartnerChange={onPartnerChange} 
                    onBuildingsChange={onBuildingsChange}
                    isMultiPartners={false}
                    partnerValue={currentPartner}
                />

                <Input
                    label={t('userActions.labels.email')}
                    name='email'
                    value={inputValues.email}
                    onChange={onInputChange}
                />

                <Input
                    label={t('userActions.labels.phone')}
                    name='phone'
                    value={inputValues.phone}
                    onChange={onInputChange}
                /> 

                <Input
                    label={t('userActions.labels.user')}
                    name='user'
                    value={inputValues.user}
                    onChange={onInputChange}
                />
            </div>

            <button
                className='bllink-button'
                onClick={onUpdateCreateClick}
                disabled={disabledBtn}
            >
                {t('userActions.btn')}
            </button>
        </StyledUserActions>
    )
};

export default UserActionsPage;
